import {
  generatePassphrase,
  generateSymbolPassword,
  estimateStrength,
  copyToClipboard
} from './password-tools.js';
if (sessionStorage.getItem('userId')) {
  location.href = '/chat.html';
}

const els = {
  tabLogin: document.getElementById('tabLogin'),
  tabRegister: document.getElementById('tabRegister'),
  authForm: document.getElementById('authForm'),
  username: document.getElementById('username'),
  password: document.getElementById('password'),
  submitBtn: document.getElementById('submitBtn'),
  authError: document.getElementById('authError'),
  authSuccess: document.getElementById('authSuccess'),
  unblockAppealBox: document.getElementById('unblockAppealBox'),
  appealMessage: document.getElementById('appealMessage'),
  appealScreenshot: document.getElementById('appealScreenshot'),
  appealPreview: document.getElementById('appealPreview'),
  submitAppealBtn: document.getElementById('submitAppealBtn'),
  appealStatus: document.getElementById('appealStatus'),
  inviteLabel: document.getElementById('inviteLabel'),
  inviteCode: document.getElementById('inviteCode'),
  passwordTools: document.getElementById('passwordTools'),
  passwordStrengthFill: document.getElementById('passwordStrengthFill'),
  passwordStrengthText: document.getElementById('passwordStrengthText'),
  genPassphraseBtn: document.getElementById('genPassphraseBtn'),
  genSymbolsBtn: document.getElementById('genSymbolsBtn'),
  copyPasswordBtn: document.getElementById('copyPasswordBtn'),
  passwordSaveHint: document.getElementById('passwordSaveHint'),
  togglePasswordBtn: document.getElementById('togglePasswordBtn'),
  passwordConfirm: document.getElementById('passwordConfirm'),
  passwordConfirmLabel: document.getElementById('passwordConfirmLabel')
};

let mode = 'login';
let appealPreviewUrl = '';
// Заполняется по /register/policy: сервер сам говорит, нужен ли код
let registrationPolicy = { inviteRequired: false, closed: false, firstUser: false };

bindPasswordTools();
const cameFromInviteLink = applyInviteFromUrl();
loadRegistrationPolicy();

els.tabLogin.addEventListener('click', () => setMode('login'));
els.tabRegister.addEventListener('click', () => setMode('register'));
els.authForm.addEventListener('submit', onSubmit);
els.appealScreenshot?.addEventListener('change', renderAppealPreview);
els.submitAppealBtn?.addEventListener('click', submitUnblockAppeal);

/*
 * Код из ссылки-приглашения (её же кодирует QR).
 * Пришли по такой ссылке — сразу открываем вкладку регистрации
 * с подставленным кодом, чтобы не заставлять переписывать его руками.
 */
function applyInviteFromUrl() {
  const code = new URLSearchParams(location.search).get('invite');
  if (!code) return false;

  if (els.inviteCode) els.inviteCode.value = code.trim().toUpperCase();

  // Чистим адресную строку: код не должен остаться в истории браузера
  history.replaceState(null, '', location.pathname);
  return true;
}

async function loadRegistrationPolicy() {
  try {
    const res = await fetch('/register/policy', { credentials: 'same-origin' });
    const data = await res.json();
    if (res.ok && data) {
      registrationPolicy = {
        inviteRequired: !!data.inviteRequired,
        closed: !!data.closed,
        firstUser: !!data.firstUser
      };
    }
  } catch {
    // Недоступность настройки не должна ломать вход
  }

  applyRegistrationPolicy();

  if (cameFromInviteLink) {
    setMode('register');
    els.authSuccess.textContent = 'Код приглашения подставлен — придумайте имя и пароль.';
  }
}

/*
 * Помощь с паролем.
 *
 * Показываем только при регистрации: при входе оценивать чужой уже
 * существующий пароль бессмысленно, а генератор там просто мешает.
 */
let lastGeneratedPassword = '';

const STRENGTH_COLORS = {
  weak: '#e2574c',
  medium: '#d99a2b',
  good: '#4fae4e',
  strong: '#3f8c3e'
};

function renderPasswordStrength() {
  const value = String(els.password.value || '');
  const generated = value === lastGeneratedPassword && !!value;
  const result = estimateStrength(value, { generated });

  const fill = els.passwordStrengthFill;
  const text = els.passwordStrengthText;
  if (!fill || !text) return;

  // Шкала до 100 бит: дальше разница уже не имеет практического смысла
  const percent = Math.max(0, Math.min(100, Math.round((result.bits / 100) * 100)));
  fill.style.width = value ? `${Math.max(percent, 6)}%` : '0%';
  fill.style.backgroundColor = STRENGTH_COLORS[result.level] || 'transparent';

  text.textContent = value
    ? `${result.label} · ${result.bits} бит${result.hint ? ' · ' + result.hint : ''}`
    : '';
}

function applyGeneratedPassword(password) {
  lastGeneratedPassword = password;
  els.password.value = password;

  // Сгенерированный показываем открытым: его надо переписать или скопировать
  els.password.type = 'text';
  els.passwordTools?.classList.add('password-generated');
  document.querySelector('.auth-card, form.auth-form')?.classList.add('password-generated');
  els.copyPasswordBtn?.classList.remove('hidden');
  els.passwordSaveHint?.classList.remove('hidden');

  // Повтор заполняем сами: поле ловит опечатку при ручном вводе,
  // а сгенерированный пароль вставила страница — опечататься там негде.
  // Заставлять переписывать семь слов руками — лишняя работа без пользы.
  // Показан он открыто, поэтому и повтор держим в том же виде
  if (els.passwordConfirm) {
    els.passwordConfirm.value = password;
    els.passwordConfirm.type = els.password.type;
  }
  markConfirmMismatch(false);

  renderPasswordStrength();
}

/*
 * Расхождение показываем рамкой, а не текстом: на странице входа
 * подписей нет, и заводить ради этого новую строку не хочется.
 * Пока повтор пуст, ничего не подсвечиваем — человек ещё печатает.
 */
function markConfirmMismatch(on) {
  els.passwordConfirm?.classList.toggle('field-mismatch', Boolean(on));
}

function syncConfirmState() {
  if (mode !== 'register' || !els.passwordConfirm) return;
  const confirmValue = els.passwordConfirm.value.trim();
  if (!confirmValue) return markConfirmMismatch(false);
  markConfirmMismatch(confirmValue !== els.password.value.trim());
}

function bindPasswordTools() {
  els.password?.addEventListener('input', () => {
    // Ручная правка означает, что пароль больше не «наш»
    if (els.password.value !== lastGeneratedPassword) lastGeneratedPassword = '';
    renderPasswordStrength();
  });

  els.passwordConfirm?.addEventListener('input', syncConfirmState);
  els.password?.addEventListener('input', syncConfirmState);

  els.togglePasswordBtn?.addEventListener('click', () => {
    const shown = els.password.type === 'text';
    els.password.type = shown ? 'password' : 'text';
    if (els.passwordConfirm) els.passwordConfirm.type = els.password.type;
    els.togglePasswordBtn.title = shown ? 'Показать пароль' : 'Скрыть пароль';
  });

  els.genPassphraseBtn?.addEventListener('click', () => {
    applyGeneratedPassword(generatePassphrase());
  });

  els.genSymbolsBtn?.addEventListener('click', () => {
    applyGeneratedPassword(generateSymbolPassword());
  });

  els.copyPasswordBtn?.addEventListener('click', async () => {
    const ok = await copyToClipboard(els.password.value);
    els.copyPasswordBtn.textContent = ok ? 'Скопировано' : 'Не вышло';
    setTimeout(() => {
      if (els.copyPasswordBtn) els.copyPasswordBtn.textContent = 'Скопировать';
    }, 1600);
  });
}

function applyRegistrationPolicy() {
  const showInvite = mode === 'register' && registrationPolicy.inviteRequired;
  els.inviteLabel?.classList.toggle('hidden', !showInvite);

  // Регистрация закрыта — прячем саму вкладку
  els.tabRegister?.classList.toggle('hidden', registrationPolicy.closed);
  if (registrationPolicy.closed && mode === 'register') setMode('login');
}

function setMode(nextMode) {
  mode = nextMode;
  hideUnblockAppeal();
  els.tabLogin.classList.toggle('active', mode === 'login');
  els.tabRegister.classList.toggle('active', mode === 'register');
  els.submitBtn.textContent = mode === 'login' ? 'Войти' : 'Создать аккаунт';
  els.password.autocomplete = mode === 'login' ? 'current-password' : 'new-password';
  applyRegistrationPolicy();
  els.passwordConfirmLabel?.classList.toggle('hidden', mode !== 'register');
  if (els.passwordConfirm) {
    els.passwordConfirm.value = '';
    els.passwordConfirm.type = els.password.type;
  }
  markConfirmMismatch(false);
  els.passwordTools?.classList.toggle('hidden', mode !== 'register');
  if (mode === 'register') renderPasswordStrength();
  clearMessages();
}

function clearMessages() {
  els.authError.textContent = '';
  els.authSuccess.textContent = '';
  if (els.appealStatus) els.appealStatus.textContent = '';
}

function showUnblockAppeal() {
  els.unblockAppealBox?.classList.remove('hidden');
}

function hideUnblockAppeal() {
  els.unblockAppealBox?.classList.add('hidden');
  if (els.appealMessage) els.appealMessage.value = '';
  if (els.appealScreenshot) els.appealScreenshot.value = '';
  if (appealPreviewUrl) {
    URL.revokeObjectURL(appealPreviewUrl);
    appealPreviewUrl = '';
  }
  if (els.appealPreview) {
    els.appealPreview.classList.add('hidden');
    els.appealPreview.innerHTML = '';
  }
  if (els.appealStatus) els.appealStatus.textContent = '';
}

function renderAppealPreview() {
  const file = els.appealScreenshot?.files?.[0] || null;
  if (appealPreviewUrl) {
    URL.revokeObjectURL(appealPreviewUrl);
    appealPreviewUrl = '';
  }
  if (!els.appealPreview) return;
  if (!file) {
    els.appealPreview.classList.add('hidden');
    els.appealPreview.innerHTML = '';
    return;
  }

  appealPreviewUrl = URL.createObjectURL(file);
  els.appealPreview.classList.remove('hidden');
  els.appealPreview.innerHTML = `<img src="${appealPreviewUrl}" alt="Доказательство">`;
}

async function submitUnblockAppeal() {
  clearMessages();
  const username = els.username.value.trim();
  const password = els.password.value.trim();
  const message = els.appealMessage?.value.trim() || '';
  const screenshot = els.appealScreenshot?.files?.[0] || null;

  if (!username || !password) {
    els.appealStatus.textContent = 'Введите логин и пароль ограниченного аккаунта';
    return;
  }
  if (message.length < 10) {
    els.appealStatus.textContent = 'Опишите обращение подробнее';
    els.appealMessage?.focus();
    return;
  }
  if (!screenshot) {
    els.appealStatus.textContent = 'Добавьте скриншот или доказательство';
    return;
  }

  const formData = new FormData();
  formData.set('username', username);
  formData.set('password', password);
  formData.set('message', message);
  formData.set('screenshot', screenshot);

  els.submitAppealBtn.disabled = true;
  els.appealStatus.textContent = 'Отправляем обращение...';
  try {
    const res = await fetch('/appeals/unblock', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    });
    const data = await res.json();
    if (!res.ok || data.ok === false) {
      els.appealStatus.textContent = data.message || 'Не удалось отправить обращение';
      return;
    }

    els.authSuccess.textContent = 'Обращение отправлено модерации';
    hideUnblockAppeal();
  } catch (err) {
    console.error('UNBLOCK APPEAL ERROR:', err);
    els.appealStatus.textContent = 'Ошибка соединения с сервером';
  } finally {
    els.submitAppealBtn.disabled = false;
  }
}

async function onSubmit(e) {
  e.preventDefault();
  clearMessages();
  hideUnblockAppeal();

  const username = els.username.value.trim();
  const password = els.password.value.trim();

  if (!username || !password) {
    els.authError.textContent = 'Заполните имя пользователя и пароль';
    return;
  }

  if (username.length < 3 || username.length > 32) {
    els.authError.textContent = 'Имя пользователя должно быть от 3 до 32 символов';
    els.username.focus();
    return;
  }

  if (mode === 'register' && (password.length < 8 || password.length > 128)) {
    els.authError.textContent = 'Пароль должен быть от 8 до 128 символов';
    els.password.focus();
    return;
  }

  // Оба значения обрезаем одинаково, иначе лишний пробел в конце
  // даст расхождение там, где пароли на деле совпадают
  if (mode === 'register' && password !== String(els.passwordConfirm?.value || '').trim()) {
    els.authError.textContent = 'Пароли не совпадают';
    markConfirmMismatch(true);
    els.passwordConfirm?.focus();
    return;
  }

  if (password.length > 128) {
    els.authError.textContent = 'Пароль слишком длинный';
    els.password.focus();
    return;
  }

  els.submitBtn.disabled = true;
  els.submitBtn.textContent = mode === 'login' ? 'Входим...' : 'Создаём...';

  try {
    if (mode === 'register') {
      const registerRes = await fetch('/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          username,
          password,
          inviteCode: String(els.inviteCode?.value || '').trim()
        })
      });

      const registerData = await registerRes.json();

      if (!registerRes.ok || registerData.success === false || registerData.ok === false) {
        els.authError.textContent = registerData.message || 'Ошибка регистрации';
        // Требования могли измениться, пока форма была открыта
        if (['INVITE_REQUIRED', 'INVITE_INVALID', 'REGISTRATION_CLOSED'].includes(registerData.code)) {
          loadRegistrationPolicy();
        }
        return;
      }

      els.authSuccess.textContent = 'Аккаунт создан. Выполняется вход...';
    }

    const loginRes = await fetch('/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ username, password })
    });

    const loginData = await loginRes.json();

    if (!loginRes.ok || !loginData.userId) {
      if (loginRes.status === 403 && /suspended|огранич/i.test(`${loginData.code || ''} ${loginData.message || ''}`)) {
        showUnblockAppeal();
      }
      els.authError.textContent = loginData.message || 'Ошибка входа';
      return;
    }

    sessionStorage.setItem('userId', loginData.userId);
    sessionStorage.setItem('username', loginData.username || username);
    sessionStorage.setItem('role', loginData.role || 'user');
    sessionStorage.setItem('avatar', loginData.avatar || '');

    location.href = '/chat.html';
  } catch (err) {
    console.error('AUTH PAGE ERROR:', err);
    els.authError.textContent = 'Ошибка соединения с сервером';
  } finally {
    els.submitBtn.disabled = false;
    els.submitBtn.textContent = mode === 'login' ? 'Войти' : 'Создать аккаунт';
  }
}
